import React, { useState, useEffect, useRef } from 'react';
import { getCustomer, focusInput } from '../../../utils/helpers';
import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import { preAuthentication, forgotPassword } from "../../../store/actions";

import Loader from '../../../assets/components/loader';

const ForgotPassword = () => {

  const customerId = getCustomer();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const forgotPasswordInfo = useSelector((state) => state.forgotPassword);

  const [user, setUser] = useState({
    email: {
      value: "",
      focused: false,
      error: ""
    }
  })

  useEffect(() => {
    if (customerId !== "") {
      navigate('/mySubscriptions');
    }
  }, [])

  useEffect(() => {
    if (forgotPasswordInfo.redirect){
      navigate('/reset-password');
    }
  },[forgotPasswordInfo.redirect])

  const handleInputChange = (ev) => {
    setUser(prevUser => ({
      ...prevUser,
      [ev.target.name]: {
        ...prevUser[ev.target.name],
        value: ev.target.value,
        focused: true,
        error: validateEmail(ev.target.value)
      }
    }))
  }

  const validateEmail = (value) => {
    let errorMessagge = ""
    const validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (value === "") {
      errorMessagge = "This field is required"
    } else if (!value.match(validRegex)) {
      errorMessagge = "Email format is incorrect";
    }
    return errorMessagge
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()
    dispatch(preAuthentication({ username: user.email.value }))
  }

  return (
    <>
      <div className='forgot-password'>
        <form className='marquet--form' onSubmit={ev => handleSubmit(ev)}>
          <div className='marquet--form--group'>
            <div onClick={ev => focusInput(ev)} className={user.email.focused === true ?
              user.email.error === "" ? "input--group input--success" : "input--group input--error" : "input--group"}>
              <label>Email</label>
              <input
                name="email"
                type="text"
                autoComplete='off'
                maxLength={30}
                onChange={ev => handleInputChange(ev)}
                value={user.email.value}/>
            </div>
            <div className="invalid--feedback">{user.email.error}</div>
          </div>
          <div className="marquet--button--group">
            <button
              className="custom--button"
              disabled={false}
              type='submit'>
              Send Verification Code
              {forgotPasswordInfo.loading && <Loader size="xs" />}
            </button>
          </div>
        </form>
      </div>
    </>
  )
}

export default ForgotPassword;